<template>
  <div>
    <div class="title">直接接入式直流电能表检定装置</div>
    <div class="sub-title">
      <span>发布时间：2021-04-20 15:43:22</span>
      <span>信息来源：</span>
    </div>
    <div class="content">
      <div style="width:120%;height:600px;overflow:hidden;border:0px">
        <div style="width:80%;height:600px;margin:-120px -20px 0px -20px;">
          <iframe src="https://www.51jianmo.com/model/?code=M0000000000070154J339&desc=0&icon=1&type=1&quick=0&opacity=0&full=1" width="100%" height="800"></iframe>
        </div>
      </div>
<!--      </div>-->
      <h3>
        产品概述
      </h3>
      <p>该装置是一套专用于直流电能表检定的台体装置，由直流电压标准源、直流电流标准源、直流小信号电压标准源、多表位检定台体、全自动检定软件等组成。功率/电能测量不确定度为0.05级，支持同时全自动检定6 块直接接入式直流电能表。
        参考标准：GB/T 33708-2017《静止式直流电能表》、JJG 842-2017《电子式直流电能表检定规程》(天恒测控参与起草)，适合于各级计量部门、电力单位、仪表制造商、直流电能表用户作为直流电能/功率检测标准使用。
      </p>
      <h3>
        主要应用
      </h3>
      <ul>
        <li>检定0.2级及以下直接接入式的直流电能表</li>
        <li>检定0.2级及以下间接接入式的直流电能表</li>
        <li>检定或校准0.2级及以下直流功率表</li>
        <li>检定或校准0.1级及以下直流分流器(选件)</li>
        <li>检定或校准0.1级及以下直流电压表</li>
        <li>检定或校准0.1级及以下直流电流表</li>
      </ul>
      <h3>
        功能特点
      </h3>
      <ul>
        <li>直流电压输出：最大达1150 V，满足1 kV电能表1.15 Un的电压试验的要求。</li>
        <li>直流电流输出：最大达600 A，可作为直接接入式直流电能表的电流输入。</li>
        <li>直流小信号电压输出：最小输出低至10 μV，是电能表进行起动试验的基础。</li>
        <li>检定时采用低电势的接线端和导线进行四线开尔文连接，可最大程度降低热电势或接触电势对电能测量的影响。</li>
        <li>辅助供电电源：可为A类电能表提供DC 24 V或AC 220 V的供电电源。</li>
        <li>时钟校验功能：具有标准秒脉冲输出/测量的功能，以检定被检表的日计时误差；内置绝对时钟接收模块，可对被检表进行北京时间对时。</li>
        <li>负载能力优异：可确保满负荷状态下量值稳定准确并长时间工作。</li>
        <li>系统可靠性高：电流、电压、小信号电压回路均相互隔离，确保被检表不被损坏。</li>
        <li>移动式测控台：可通过其液晶触摸屏观察或控制量值输出，方便用户手动检表。</li>
        <li>多表位检定台：同时支持6块直接接入式直流电能表的全自动检定。检定台内嵌高清显示窗口，便于用户观察与记录被检表的工作状态。</li>
        <li>自动检定软件：支持直流电能表的半自动或全自动检定，数据管理和证书导出。</li>
        <li>分流器压接装置：手动将被检分流器的电流端子压紧，与电流源连接组成电流回路。</li>
      </ul>
      <div>
        <h3>
          装置概览
        </h3>
        <img style="width: 600px;height: 500px;text-align: center" class="icon-360" src="../../../assets/images/nqi-device.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less" scoped>
.title {
  margin-bottom: 6px;
  font-size: 36px;
  font-weight: 500;
  line-height: 50px;
  color: rgba(0, 0, 0, 0.85);
  text-align: center;
}
.sub-title {
  margin-bottom: 24px;
  padding-bottom: 30px;
  font-size: 12px;
  line-height: 17px;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  span:first-child {
    margin-right: 15px;
  }
}
.content {
  padding-bottom: 34px;
  p {
    margin-bottom: 24px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 28px;
    letter-spacing: 1px;
    text-indent: 2em;
  }
  .video-box {
    margin: 0 auto;
    margin-bottom: 24px;
    width: 748px;
    height: 426px;
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/article/components/TextContent.vue